module.exports = __webpack_public_path__ + "img/advantageOrange.cb9b2eb7.jpg";